import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './stores';
import { Router, Route, hashHistory } from 'react-router';

import App from './containers/App';
import About from './containers/About';

const store = configureStore();

render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App} />
      <Route path="/channels/:channel" component={App} />
      <Route path="/about" component={About} />
    </Router>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js